module.exports = __webpack_public_path__ + "img/rene-aguero3.e503bcf2.png";